import { render, staticRenderFns } from "./AegCaseJewellersBlock.vue?vue&type=template&id=3e1c2bc0"
import script from "./AegCaseJewellersBlock.vue?vue&type=script&lang=js"
export * from "./AegCaseJewellersBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports